import { POcomparisonTypes } from './actionTypes';

const INIT_STATE = {
  data: [],
  milestoneConfig: [],
  CountItems: 0,
  isLoading: false,
  error: {},
};

const POcomparison = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case POcomparisonTypes.GET_COMODITY_LIST_BY_PO:
      return {
        ...state,
        isLoading: true,
      };

    case POcomparisonTypes.GET_COMODITY_LIST_BY_PO_SUCCESS:
      return {
        ...state,
        data: action.payload.comodityData,
        CountItems: action.payload.CountItems,
        /* milestoneConfig: action.payload, */
        isLoading: false,
      };

    case POcomparisonTypes.GET_COMODITY_LIST_BY_PO_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default POcomparison;
